import React, { useEffect } from "react";
import { Box, Button, CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import CustomTable, { Column, Data } from "@Components/Table";
import AddPlusIcon from "@src/Constants/svg/AddPlusIcon";
import { useAppDispatch, useAppSelector } from "@hooks";
import { RootState } from "@Store";
import { appsListRequest, setModalCreateApp } from "@Store/Apps/actions";
import { selectAppsList, selectAppsListLoading } from "@Store/Apps/selectors";
import { IApp } from "@API/Apps/types";
import CreateAppModal from "@Pages/System/CreateAppModal";
import "./styles.scss";

const AppsPage: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const history = useHistory();

  const { isLoading, appsList } = useAppSelector((state: RootState) => ({
    isLoading: selectAppsListLoading(state),
    appsList: selectAppsList(state),
  }));

  useEffect(() => {
    dispatch(appsListRequest());
  }, [dispatch]);

  const columns: Column[] = [
    { field: "appId", headerName: t("apps.columns.appId") },
    { field: "appName", headerName: t("apps.columns.appName") },
  ];

  const data: Data[] = appsList.map((app: IApp, index: number) => ({
    id: index + 1,
    appId: app.appId,
    appName: app.appName,
  }));

  return (
    <Box className="root system-apps-page">
      <div className="clients-organisation-header">
        <h2>{t("apps.title")}</h2>
        <Button
          variant="contained"
          color="primary"
          style={{ borderRadius: "4px" }}
          onClick={() => dispatch(setModalCreateApp())}
        >
          <AddPlusIcon />
          <span
            style={{ marginLeft: "10px", color: "#000", fontWeight: "600" }}
          >
            {t("apps.buttons.addApp")}
          </span>
        </Button>
      </div>

      {isLoading && appsList.length === 0 ? (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            mt: 8,
          }}
        >
          <CircularProgress color="warning" />
        </Box>
      ) : (
        <CustomTable
          columns={columns}
          data={data}
          rowsPerPage={10}
          selectable={false}
          menuItems={[
            {
              name: t("apps.buttons.policies"),
              onClick: (row: Data) => {
                history.push(
                  `/system/app-policies?appId=${encodeURIComponent(
                    String(row.appId)
                  )}`
                );
              },
            },
          ]}
        />
      )}

      <CreateAppModal />
    </Box>
  );
};

export default AppsPage;
